import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallHandelssortimentBaseCommand } from "./ProduktionsmallHandelssortimentBaseCommand";

export class DeleteProduktionsmallHandelssortimentCommand extends ProduktionsmallHandelssortimentBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteProduktionsmallHandelssortimentCommand";

    constructor(produktionsmallGuid: string, handelssortimentId: number) {
        super(DeleteProduktionsmallHandelssortimentCommand.$type, CommandType.Delete);
        this.produktionsmallGuid = produktionsmallGuid;
        this.handelssortimentId = handelssortimentId;
    }
}
